interface BarsProps {
  data: number[];
  tone?: 'primary' | 'accent' | 'neutral';
}

export default function Bars({ data, tone = 'neutral' }: BarsProps) {
  const max = Math.max(...data);
  const min = Math.min(...data);
  const span = max - min || 1;
  const neutralCls = 'bg-foreground-300/60';
  const toneCls =
    tone === 'primary' ? 'bg-primary-400' : tone === 'accent' ? 'bg-accent-400' : neutralCls;
  return (
    <div className="flex h-7 items-end gap-[3px]" aria-hidden="true">
      {data.map((v, i) => {
        const ratio = ((v - min) / span) * 0.7 + 0.3;
        const isLast = i === data.length - 1;
        return (
          <div
            key={i}
            style={{ height: `${Math.round(ratio * 100)}%` }}
            className={`w-[5px] rounded-sm ${isLast ? toneCls : neutralCls}`}
          />
        );
      })}
    </div>
  );
}